<template>
    <div><button @click="isSheetOpen = true">Open sheet</button></div>
    <div><button @click="isCustomSizeSheetOpen = true">Sheet with medium size</button></div>
    <div><button @click="isCustomFooterSheetOpen = true">Sheet with custom footer</button></div>
    <div><button @click="isNoBackdropCloseSheetOpen = true">Sheet without backdrop close</button></div>

    <DsSheet
        v-model:open="isSheetOpen"
        :primary-loading="isSaving"
        primaryLabel="Save changes"
        secondaryLabel="Cancel"
        title="Default sheet"
        @clickPrimary="onPrimary"
        @clickSecondary="onSecondary"
    >
        <p>{{ paragraph(500) }}</p>
    </DsSheet>

    <DsSheet
        v-model:open="isCustomSizeSheetOpen"
        size="md"
        title="Medium sheet"
    >
        <p>Sheet content.</p>
    </DsSheet>

    <DsSheet
        v-model:open="isCustomFooterSheetOpen"
        title="Custom footer"
    >
        <p>Sheet content.</p>

        <template #footer>
            <div class="flex grow justify-center">
                <DsButton
                    size="md"
                    variant="secondary"
                >
                    <DsIcon
                        class="mr-2"
                        icon="fa-solid fa-download"
                        size="sm"
                        @click="isCustomFooterSheetOpen = false"
                    />
                    Download receipt
                </DsButton>
            </div>
        </template>
    </DsSheet>

    <DsSheet
        v-model:open="isNoBackdropCloseSheetOpen"
        :closeOnBackdropClick="false"
        secondaryLabel="Close"
        title="No backdrop close"
        @clickSecondary="isNoBackdropCloseSheetOpen = false"
    >
        <p>Clicking the backdrop does not close this sheet. Use the X button, Escape, or the close button.</p>
    </DsSheet>
</template>

<script setup lang="ts">
import DsIcon from '@ds/DsIcon.vue';
import DsSheet from '@ds/DsSheet.vue';
import DsButton from '@ds/button/DsButton.vue';
import { ref } from 'vue';

const isSheetOpen = ref(false);
const isCustomSizeSheetOpen = ref(false);
const isCustomFooterSheetOpen = ref(false);
const isNoBackdropCloseSheetOpen = ref(false);
const isSaving = ref(false);

const onPrimary = async () => {
    isSaving.value = true;
    try {
        await new Promise(resolve => setTimeout(resolve, 1500));
        isSheetOpen.value = false;
    } finally {
        isSaving.value = false;
    }
};

const onSecondary = () => {
    isSheetOpen.value = false;
};

function word() {
    return btoa(Math.random().toString()).slice(0, Math.random() * 10);
}

function paragraph(words: number) {
    return new Array(words).fill(0).map(word).join(' ');
}
</script>
